import { render, staticRenderFns } from "./SemenIssue.vue?vue&type=template&id=2f217266&scoped=true&"
import script from "./SemenIssue.vue?vue&type=script&lang=js&"
export * from "./SemenIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f217266",
  null
  
)

export default component.exports